import React, { useContext } from "react";
import { AuthContext } from "../../context/Auth/AuthContext";
import { hasRolloutFeature, ROLLOUT_FEATURES } from "../../utils/rolloutFeatures";
import LegacyWizard from "./ApiBroadcastWizardLegacy";
import RolloutWizard from "./ApiBroadcastWizardRollout";

const ApiBroadcastWizard = props => {
  const { user } = useContext(AuthContext);
  const enabled =
    hasRolloutFeature(user, ROLLOUT_FEATURES.ALL_CONTACTS) ||
    hasRolloutFeature(user, ROLLOUT_FEATURES.BROADCAST_METRICS);
  const Wizard = enabled ? RolloutWizard : LegacyWizard;
  return <Wizard {...props} />;
};

export default ApiBroadcastWizard;
